import * as moment from "moment";

import * as Models from "../Models";
import { linkToDocumentLink } from "./links";
import _ from "lodash";

export const acceptDocumentType: Function = (type: string): boolean => {
  return !(type === undefined || type === "" || type === "Other");
};

export const acceptDocumentName: Function = (name: string): boolean => {
  if (name === undefined || name === "") {
    return false;
  }

  const re: RegExp = /^[\(\)\-0-9a-zA-ZäöåÄÖÅ_ ... ]+$/;
  const acceptRe: boolean = re.test(name);
  const isNotOnlySpaces: boolean = name.trim().length !== 0;

  return acceptRe && isNotOnlySpaces;
};

export const canRemoveFile: Function = (
  meta: Models.DocumentMeta,
  user: Models.User,
  userMode: boolean
): boolean => {
  // var fileUploaded: Date = new Date(meta.created);
  // var hoursSinceUpload: number = Math.floor(moment(new Date()).diff(moment(fileUploaded), 'hours', true));
  let allowRemove: boolean;
  if (!meta.createdBy) {
    allowRemove = false;
  } else if (user.isAdminUser && !userMode) {
    allowRemove = true;
  } else if (user.userName === meta.createdBy) {
    allowRemove = true;
  } else allowRemove = false;
  return allowRemove;
};

export const getActiveDetailDocuments: Function = (
  activeDetail: Models.ActiveDetail
): Models.DocumentLink[] => {
  if (activeDetail === undefined) {
    return [];
  }

  const dataGroup: Models.DataGroup = _.find(
    activeDetail.detail.dataGroups,
    (dataGroup: Models.DataGroup) =>
      dataGroup.name.toLocaleLowerCase() === "documents"
  );

  if (dataGroup === undefined) {
    return [];
  }

  const group: Models.AttributeGroup[] = _.filter(
    dataGroup.attributeGroups,
    (ag) => ag.rows.length > 0
  );
  var rows: Models.AttributeRow[] = _.flatten(_.map(group, (g) => g.rows));
  var links: Models.Link[] = _.flatten(_.map(rows, (g) => g.items[1].url));

  var documentLinks: Models.DocumentLink[] = links.map((l) =>
    linkToDocumentLink(l, activeDetail.detail.id)
  );
  return documentLinks;
};
